import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: () => api.sites.list(),
  });
}

export function useSite(siteId: string | undefined) {
  return useQuery({
    queryKey: ['site', siteId],
    queryFn: () => api.sites.get(siteId!),
    enabled: Boolean(siteId),
  });
}
